export default "__VITE_ASSET__Bj1KOxnh__"